import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spinner } from './Spinner';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading, provinceId } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Store current URL for redirect after login
    sessionStorage.setItem('returnUrl', location.pathname);
    return <Navigate to="/" replace />;
  }

  // If user has no province and not on create page, redirect to create
  if (!provinceId && location.pathname !== '/create-province') {
    return <Navigate to="/create-province" replace />;
  }

  // If user has province and on create page, redirect to throne room
  if (provinceId && location.pathname === '/create-province') {
    return <Navigate to="/province" replace />;
  }

  return <Outlet />;
}
